export {default as RecordList} from "./List";
export {default as RecordExam} from "./Exam";
